import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { CONTENT } from "@/content";

const A = CONTENT.admin;
const today = () => new Date().toLocaleDateString("en-CA");

const statusOf = (item) => {
  if (item.status === "draft") return A.statusDraft;
  return item.publish_date > today() ? A.statusScheduled : A.statusLive;
};

const DeleteButton = ({ item, onDelete }) => (
  <AlertDialog>
    <AlertDialogTrigger asChild>
      <button className="nb-btn ghost small" data-testid={`content-delete-${item.id}`}>{A.delete}</button>
    </AlertDialogTrigger>
    <AlertDialogContent className="nb-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>{A.deleteTitle}</AlertDialogTitle>
        <AlertDialogDescription>{item.title}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="content-delete-cancel">{A.cancel}</AlertDialogCancel>
        <AlertDialogAction onClick={() => onDelete(item)} data-testid="content-delete-confirm">{A.delete}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const ContentList = ({ items, onEdit, onDelete }) => {
  if (!items) return <p className="muted">{A.loading}</p>;
  if (!items.length) return <div className="nb-card" data-testid="content-empty"><p className="panel-line">{A.empty}</p></div>;
  return (
    <ul className="content-list" data-testid="content-list">
      {items.map((item) => (
        <li key={item.id} className="nb-card content-row" data-testid={`content-row-${item.id}`}>
          <div className="row-main">
            <div className="row-tags">
              <span className="pill" data-testid={`content-status-${item.id}`}>{statusOf(item)}</span>
              {item.category && <span className="pill light">{item.category}</span>}
              <span className="row-date">{item.publish_date}</span>
            </div>
            <h3 className="row-title">{item.title}</h3>
            <p className="row-ref">{item.verse_reference}{item.translation ? ` · ${item.translation}` : ""}</p>
          </div>
          <div className="row-actions">
            <button className="nb-btn small" onClick={() => onEdit(item)} data-testid={`content-edit-${item.id}`}>{A.edit}</button>
            <DeleteButton item={item} onDelete={onDelete} />
          </div>
        </li>
      ))}
    </ul>
  );
};
